import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { createI18n } from 'vue-i18n-composable'

import {
    app, days, errors, footer, globals, logos, meta, numberFormats
} from '@/i18n/pl'

Vue.use(VueI18n)

export default createI18n({
    locale: 'pl',
    messages: {
        pl: {
            days: days,
            errors: errors,
            footer: footer,
            globals: globals,
            logos: logos,
            meta: meta,
            ...app
        }
    },
    numberFormats: numberFormats
})
